
/* globals app, ajaxify, socket */

var usersonlinedata = {};

function renderOnlineUsers() {

	if (app.user.uid <= 0) {
		return;
	}

	if (socket.disconnected) {
		// Le client est déconnecté alors on réinitialise
		usersonlinedata = {};
		$('.online-users-YA').children().fadeOut(500, function() { $(this).remove(); });
		// On change le statut client
		changeClientStatus("offline");
		// On actualise les pastilles offline...
		actualisePastillesOffline(usersonlinedata);
	}

	if (socket.connected) {
		socket.emit('plugins.onlineUsers.getOnlineUsers', function (err, data) {
			if (err) {
				return app.alertError(err.message);
			}
			if (!data) {
				changeClientStatus("offline");
				usersonlinedata = {};
				actualisePastillesOffline(usersonlinedata);
				return;
			}

			if ( app.user.uid in data ) {
				changeClientStatus(data[app.user.uid]['status']);
			}

			// On regarde d'abord ce qui est à changer dans les users existants dans usersonlinedata

			var uidindata = Object.keys(data);
			var uidinusersonlinedata = Object.keys(usersonlinedata);

			uidinusersonlinedata.forEach(function(uid) {
				if ( uidindata.includes(uid) ) {
					// uid déjà présent
					if ( data[uid]['status'] != usersonlinedata[uid]['status'] ) {
						// Nouveau statut !
						usersonlinedata[uid]['status'] = data[uid]['status'];
						UpdateUidStatus(uid,usersonlinedata[uid]['status']);
					}
					uidindata = uidindata.filter(function(item) { return item !== uid });
				} else {
					// uid à supprimer
					delete usersonlinedata[uid];
					RemoveUid(uid);
				}
			});

			// On poursuit en regardant les éléments restants (nouveaux) dans data à ajouter

			uidindata.forEach(function(uid) {
				// Nouvel uid à ajouter
				usersonlinedata[uid] = JSON.parse(JSON.stringify(data[uid])); // shallow copy
				AjouteUid(usersonlinedata[uid]);
			});
		});
	}
}

function changeClientStatus(newstatus) {
	if ( app.user.status != newstatus ) {
		app.user.status = newstatus;
	}
}

function UpdateUidStatus(uid, status) {
	// Pour changer le statut de cet uid
	$('[component="user/status"][data-uid="' + uid + '"]').each(function() {
		if ( !($(this).hasClass(status) ) ) {
			var toremove = ['away', 'online', 'dnd', 'offline'].filter(function(item) { return item !== status });
			$(this).addClass(status).removeClass(toremove);
		}
	});
}

function RemoveUid(uid) {
	// Pour enlever l'user uid
	$('.online-users-YA a[data-uid="' + uid + '"]').fadeTo(300,0).animate({width: 0}, 300, function() {
		$(this).remove();
	});
	UpdateUidStatus(uid, 'offline');
}

function AjouteUid(userdata) {
	// Pour ajouter un user si pas déjà là
	if ( $('.online-users-YA a[data-uid="' + userdata.uid + '"]').length === 0 ) {
		// Pas déjà présent donc on ajoute
		app.parseAndTranslate('widgets/onlineusersYAuser', { onlineUsersYA: userdata }, function (html) {
			var onlineUsersEl = $('.online-users-YA');
			app.createUserTooltips(html);
			onlineUsersEl.append(html);
			$('.online-users-YA a[data-uid="' + userdata.uid + '"]').fadeIn(700);
			UpdateUidStatus(userdata.uid, userdata.status);
		});
	} else {
		// Update status éventuel
		UpdateUidStatus(userdata.uid, userdata.status);
	}
}


function actualisePastillesOffline(data) {
	// Mise à jour de toutes les pastilles nécessaires pour tous les clients non présents dans data
	var uidindata = Object.keys(data);
	$('[component="user/status"]').each(function() {
		var datauid = $(this).attr("data-uid");
		if ( !(uidindata.includes(datauid)) ) {
			if ( $(this).hasClass('away') || $(this).hasClass('online') || $(this).hasClass('dnd') ) {
				$(this).addClass('offline').removeClass('away online dnd');
			}
		}
	});
}

$(document).ready(function () {
	'use strict';

	// Pour les statuts de la shoutbox au chargement, voir dans base.js du plugin shoutbox...

	$(window).on('action:widgets.loaded', function (ev, data) {
		usersonlinedata = {};
		renderOnlineUsers();
	});

	// Yannick : Fired upon a connection including a successful reconnection
	socket.on('connect', function () {
		setTimeout(function() { // On met un délai de 500 ms au cas où déconnexion rapide
			if (socket.connected) {
				renderOnlineUsers();
			}
		}, 500); // en ms
	});

	// Yannick : Fired upon a disconnection
	socket.on('disconnect', function (reason) {
		setTimeout(function() { // On met un délai de 5000 ms au cas où reconnexion rapide
			if (socket.disconnected) {
				renderOnlineUsers();
			}
		}, 5000); // en ms
	});

	// Yannick : Fired upon an update call from server
	socket.on('plugins.onlineUsers.updateOnlineUsers', function () {
		renderOnlineUsers();
	});

	// Yannick : Fired upon a status change coming from server
	socket.on('event:user_status_change', function () {
		renderOnlineUsers();
	});

	///////////////////////////////////
	// Yannick : Begin of activity system
	//
	// Si l'user ne fait rien pendant un certain temps, le serveur ne recevra aucune indication d'activité et le commutera en "away" si il était "online".
	//
	// Si page hidden, le client le signale au serveur qui avise un peu après.
	//
	// Si l'user déclenche un event parmi events sur une page ou change l'état de visibilité de celle-ci, et qu'il était en "away", il passe en "online".

	// Ajout de détection d'évènements de l'user pour voir son activité
	var events = ['mousedown', 'mousemove', 'keypress', 'touchstart', 'touchmove',  'scroll', 'DOMMouseScroll', 'MSPointerMove', 'mousewheel', 'focus'];
	function AddDetectEvents() {
		events.forEach(function(name) {
			window.addEventListener(name, OnEventDetected, false);
		});
	}

	AddDetectEvents();

	// Action si évènement détecté
	var debouncetimer = null;
	var debouncedelay = 5000;
	function OnEventDetected () {
		// Action à faire (mais sans la répéter si appelée ensuite dans le délai de debouncedelay (en ms) pour ne pas charger inutilement le serveur d'appels redondants !)
		if ( debouncetimer == null ) {
			userisactive();
			debouncetimer = setTimeout(function() {debouncetimer = null;}, debouncedelay);
		}
	}

	// Fonction appelée en cas d'user vu comme inactif
	function userisinactive() {
		if ( app.user.status == "online" ) {
			// Le client signale au serveur qu'il n'y a pas de vie ici (activity=false)...
			socket.emit('plugins.onlineUsers.UserActivity', false);
		}
	}

	// Fonction appelée en cas d'activité de l'user
	function userisactive() {
			// Le client signale au serveur qu'il y a de la vie ici (activity=true)...
			socket.emit('plugins.onlineUsers.UserActivity', true);
	}

	//// Aspects introduits grâce à Visibility API
	// Détection préalable des préfixes pour chaque moteur et stockage de leur nom dans des variables
	var prefixes = ['', 'moz', 'ms', 'o', 'webkit'];
	for (var i = 0; i < prefixes.length; i++) {
		if (prefixes[i] == '') {
			var testname = 'hidden';
		} else {
			var testname = prefixes[i] + 'Hidden';
		}
		if (testname in document) {
			var hidden = testname;
			var visibilityChange = prefixes[i] + 'visibilitychange';
			break;
		}
	}

	// La variable hidden contient le nom de la propriété du document
	// La variable visibilityChange contient le nom de l'événement

	document.addEventListener(visibilityChange, changementVisibilite, false);

	// Fonction qui traite l'événement de changement de visibilité
	function changementVisibilite() {
		// document[hidden] contient true si tab/fenêtre cachée/réduite et false sinon
		if (document[hidden]) {
			// Fenêtre réduite donc on signale l'inactivité après un petit délai
			setTimeout(function() {
				if (document[hidden]) {
					userisinactive();
				}
			}, 1000);
		} else {
			setTimeout(function() {
				if (!document[hidden]) {
					debouncetimer = null;
					OnEventDetected();
				}
			}, 300);
		}
	}


	// End of activity system
	///////////////////////////////////

});

